import { render, staticRenderFns } from "./curationUsersPage.vue?vue&type=template&id=6b9c4dd0&scoped=true&"
import script from "./curationUsersPage.vue?vue&type=script&lang=js&"
export * from "./curationUsersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c4dd0",
  null
  
)

export default component.exports